import ProductCategoryListContainer from './ProductCategoryListContainer';
export default ProductCategoryListContainer;
